import { headers } from "../../App/Axios"
import HTTPService from "../../App/HTTPService"

export const upcomingUserEventsGetRequest = () => {
    return HTTPService.get(`/events/upcoming/`, headers)
}

export const upcomingOrganizationEventsGetRequest = (orgId: string) => {
    return HTTPService.get(`/events/upcoming?org_id=${orgId}`, headers)
}